export abstract class ReportManager {
  protected payoutDetails: Array<any> = [];
  protected transactionDetails: Array<any> = [];

  public setPayoutDetails(details: Array<any>) {
    this.payoutDetails = details;
  }
  public setTransactionDetails(details: Array<any>) {
    this.transactionDetails = details;
  }
  public abstract getTransactionHeaders(): Array<string>;
  public getPayoutHeaders(): Array<string> {
    // Backward compatibility: reports generated before the payout columns "Status", "Type" and
    // "Date of Transactions" were added are stored on AWS with the older (9 column) layout. Pick the
    // header set that matches the stored data so old reports keep downloading without column mismatch.
    if (this.payoutDetails[0]?.length <= 9) {
      return ["ID", "Created Date", "Transactions", "Currency", "Gross", "Deductions", "Net", "Category", "Comments"]
    }
    return ["ID", "Created Date", "Status", "Type", "Date of Transactions", "Transactions", "Currency", "Gross",
      "Deductions", "Net", "Category", "Comments"]
  }

  public getDisputeHeaders(): Array<string> {
    return ["ID", "Created Date", "Currency", "Amount", "Original Transaction Id", "Original Transaction Date", "Reason"]
  }

  public getReserveHeaders(): Array<string> {
    return ["ID", "Created Date", "Category", "Currency", "Amount", "Original Transaction Id", "Original Transaction Date", "Comments"]
  }

}